import { render } from "./HistoryPointPage.vue?vue&type=template&id=3c3037e4"
import script from "./HistoryPointPage.vue?vue&type=script&lang=js"
export * from "./HistoryPointPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__